module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/stream-browserify/node_modules/readable-stream/transform.js
// module id = 1177
// module chunks = 0